export default Object.freeze({
  BANNERS_REQUEST: 'BANNERS_REQUEST',
  BANNERS_SUCCESS: 'BANNERS_SUCCESS',
  BANNERS_FAILURE: 'BANNERS_FAILURE'
});
